import { render } from "./NavGroupDesktop.vue?vue&type=template&id=04cdd8f1&scoped=true"
import script from "./NavGroupDesktop.vue?vue&type=script&lang=js"
export * from "./NavGroupDesktop.vue?vue&type=script&lang=js"

import "./NavGroupDesktop.vue?vue&type=style&index=0&id=04cdd8f1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04cdd8f1"

export default script